



















import { Vue, Component } from 'vue-property-decorator';

import SIDE_BAR_MENUS from '@/constants/sideBarMenu';
import { logoImage, logoInvertedImage } from '@/assets/images';

@Component
export default class SideBar extends Vue {
  private logo = logoImage;
  private sideBarMenus = SIDE_BAR_MENUS;
}
